import { BasketResponseError } from '../errors';

export const isBasketResponseError = (error: unknown): error is BasketResponseError => {
    return error instanceof BasketResponseError;
};
